import { render, staticRenderFns } from "./CloudColorPicker.vue?vue&type=template&id=2fda7e28"
import script from "./CloudColorPicker.vue?vue&type=script&lang=js"
export * from "./CloudColorPicker.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports